import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { Aereo, Pacote } from 'src/app/model';
import { AereoService, Util } from 'src/app/services';
import { ModalComponent } from '../../modal/modal.component';

export const ORCAMENTO = 'orcamentousuario';

@Component({
  selector: 'app-aereo-card',
  templateUrl: './aereo-card.component.html',
  styleUrls: ['./aereo-card.component.scss'], standalone: false
})
export default class AereoCardComponent implements OnInit {
  @ViewChild('modalReserva') private modalReserva: ModalComponent;
  @ViewChild('modalEmitirAereo') private modalEmitirAereo: ModalComponent;
  @ViewChild('modalCancelarAereo') private modalCancelarAereo: ModalComponent;

  @Input() aereo: Aereo;
  @Input() pacote: Pacote;
  @Input() index: number;
  @Input() statusOrcamento: number
  @Input() termometroValido: boolean;
  @Input() dentroDoOrcamento: boolean = true;
  @Input() executarGetAereo: boolean = false;
  @Input() idadeInvalida: boolean = true;
  @Input() LiberarVoucher: boolean = false;
  @Input() cardSimplificado: boolean = false;
  @Input() cardItem: any;

  @Output() verificaIdadeValida: EventEmitter<void> = new EventEmitter<void>();
  @Output() imprimirVoucherEmitter = new EventEmitter<Aereo>();
  @Output() carregarObjetoEmitter = new EventEmitter<number>();
  @Output() atualizarAereoEmitter: EventEmitter<number> = new EventEmitter();

  spinnerAereo: boolean = false;
  carregando: boolean = false;
  mensagemSucessoAereo: string = '';
  mensagensErroAereo: string = '';

  user: any;

  constructor(
    private aereoService: AereoService,
    private utilService: Util,
  ) { }


  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('loggedUser'));
    
    if (this.cardSimplificado) {
      if(this.cardItem != null && this.cardItem != undefined){
        this.aereo = this.cardItem;
        this.carregando = false;
      } else if (this.executarGetAereo) {
        this.getAereo();
      }
    } else if (this.executarGetAereo) {
      this.getAereo();
    }
  }

  delete() {
    const confirmacao = confirm('Deletar aéreo?');
    if (confirmacao === true) {
      sessionStorage.removeItem(ORCAMENTO);
    }
  }

  temRC(tarifas) {
    return tarifas.some(x => x.ValorTaxaDUListagem > 0);
  }

  atualizarAereo(aereo) {
    this.aereo = aereo;
    this.carregarObjetoEmitter.emit(this.aereo.ReservaId);
  }

  confirmarRemoverAereo(aereo) {
    const resposta = window.confirm(
      `Tem certeza que deseja excluir o aéreo: ${aereo.Id} ?`
    );

    if (resposta) {
      this.spinnerAereo = true;
      this.removerAereo(aereo);
    }
  }

  removerAereo(aereo) {
    this.mensagemSucessoAereo = '';
    this.mensagensErroAereo = '';

    if (this.termometroValido) {
      alert(this.utilService.fazerTraducao("Necessário retornar o valor do termômetro para padrão antes de remover esse item."));
      return;
    }

    this.aereoService.removerAereo(aereo).subscribe(
      (dados) => {
        // this.Orcamento.Aereos = this.Orcamento.Aereos.filter(
        //   (x) => x.Id !== dados.Id
        // );
        this.mensagemSucessoAereo = `Aéreo ${dados.Id} removido com sucesso!`;
        this.atualizarAereoEmitter.emit(dados.Id)
        this.carregarObjetoEmitter.emit(dados.ReservaId);
        this.spinnerAereo = false;
      },
      (erro) => {
        this.mensagensErroAereo = this.utilService.errorHandler(erro);
        this.spinnerAereo = false;
      }
    );
  }

  getAereo() {
    this.carregando = true;
    this.aereoService.tarifarAereo(this.aereo, true).subscribe(
      (dados) => {
        this.aereo = dados;
        this.carregando = false;
      },
      (erro) => {
        console.log(erro);
        this.mensagensErroAereo = this.utilService.errorHandler(erro, 'carregar aéreo');
        this.carregando = false;
      }
    );
  }

  validaSePodeReservar() {
    this.verificaIdadeValida.emit();
    if (this.idadeInvalida) {
      this.mensagensErroAereo = this.utilService.fazerTraducao('Verifique a Idade dos passageiros');
      return;
    } else {
      this.modalReserva.open();
    }
  }
}
